import type {
  EventSelectionMap,
  KeyEventDescriptor,
  KeyEventSelection,
  PrimaryEventMap,
} from '../models/conversion.types'
import { buildKeyEventValues } from '../service/keyEvents'

import {
  SaveAttributeFlow,
  type AttributeBatchItem,
  type SaveAttributeBatchResult,
} from '@/features/workspace-settings'

export interface SaveKeyEventsInput {
  descriptor: KeyEventDescriptor
  accountId: string
  selection: KeyEventSelection
  current: {
    events: EventSelectionMap | null
    primary: PrimaryEventMap | null
  }
  ids: {
    events: number | null
    primary: number | null
    ga4Set?: number | null
  }
}

export class SaveKeyEventsFlow {
  constructor(private readonly attributes = new SaveAttributeFlow()) {}

  async save(input: SaveKeyEventsInput): Promise<SaveAttributeBatchResult> {
    const next = buildKeyEventValues({
      descriptor: input.descriptor,
      accountId: input.accountId,
      selection: input.selection,
      events: input.current.events,
      primary: input.current.primary,
    })
    const items: AttributeBatchItem[] = [
      {
        key: input.descriptor.eventsKey,
        value: next.events,
        attributeId: input.ids.events,
      },
      {
        key: input.descriptor.primaryKey,
        value: next.primary,
        attributeId: input.ids.primary,
      },
    ]
    if (next.ga4Set) {
      items.push({ key: 'ga4_key_events_set', value: true, attributeId: input.ids.ga4Set })
    }
    return this.attributes.saveBatch(items)
  }
}
